if (!process.env.NEXT_PUBLIC_WORDPRESS_URL) {
  throw new Error('NEXT_PUBLIC_WORDPRESS_URL is not defined')
}

const NEXT_PUBLIC_WORDPRESS_URL = process.env.NEXT_PUBLIC_WORDPRESS_URL.replace(/\/?$/, '/')
export const GRAPHQL_ENDPOINT = `${NEXT_PUBLIC_WORDPRESS_URL}graphql`
